import { useEffect } from "react";
import { loginWithTrustNGO, isAuthenticated } from "@/lib/trustngo-auth";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Shield } from "lucide-react";

const AdminLoginPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated()) {
      navigate("/admin");
    }
  }, [navigate]);

  return (
    <Layout>
      <div className="min-h-[70vh] flex items-center justify-center py-12 px-4">
        <Card className="w-full max-w-md border-primary/20">
          <CardHeader className="text-center space-y-2">
            <div className="mx-auto w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
              <Shield className="h-6 w-6 text-primary" />
            </div>
            <CardTitle className="text-2xl">Admin Access</CardTitle>
            <CardDescription>
              Sign in with your TrustNGO account to access the admin dashboard
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Button
              onClick={() => loginWithTrustNGO()}
              className="w-full"
              size="lg"
            >
              Sign in via TrustNGO SSO
            </Button>
            <p className="text-xs text-center text-muted-foreground">
              You will be redirected to the TrustNGO authentication portal
            </p>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default AdminLoginPage;
